var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "w-full py-2.5 bg-pure-white",
      style: { minHeight: "800px" }
    },
    [
      _c(
        "div",
        {
          staticClass: "px-6.5 pb-1 flex items-center justify-between gap-16",
          attrs: { id: "template-header" }
        },
        [
          _c("div", { staticClass: "flex-shrink-0" }, [
            !_vm.currentCenter.logo_url
              ? _c(
                  "div",
                  {
                    staticClass:
                      "h-6.5 w-20 border border-slate-400 rounded flex items-center justify-center"
                  },
                  [
                    _c("div", { staticClass: "text-xxs text-slate-800" }, [
                      _vm._v("Center logo")
                    ])
                  ]
                )
              : _c("img", {
                  staticClass: "h-6.5",
                  attrs: { src: _vm.currentCenter.logo_url, alt: "logo_url" }
                })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right text-xxs text-slate-700 truncate" },
            [
              _c("div", { staticClass: "truncate" }, [
                _vm._v(_vm._s(_vm.client.name))
              ]),
              _vm._v(" "),
              _c("div", [_vm._v("Report for DD/MM/YYYY - DD/MM/YYYY")])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.template !== "blank"
        ? _c("div", { staticClass: "px-6.5 py-0.5" }, [
            _vm.template === "selected_curricula_or_target_types"
              ? _c("div", { staticClass: "text-slate-1000" }, [
                  _c("div", { staticClass: "text-xs font-semibold" }, [
                    _vm._v("Curriculum A")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-xs" }, [
                    _vm._v(
                      "\n        A total of 3 targets are associated with this curriculum.\n      "
                    )
                  ])
                ])
              : _c("div", { staticClass: "flex flex-col gap-1" }, [
                  _c("div", {
                    staticClass: "h-2.5 w-full rounded-full bg-slate-400"
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "h-2.5 w-2/3 rounded-full bg-slate-400"
                  })
                ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.template === "progress_highlights" ||
      _vm.template === "mastered_targets"
        ? _c(
            "div",
            { attrs: { id: "exmaple-cumulative" } },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("ExampleCumulative", { staticClass: "w-full" })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.template !== "blank"
        ? _c(
            "div",
            { attrs: { id: "exmaple-target-graph" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "py-1 flex flex-col items-center justify-center text-slate-1000"
                },
                [
                  _c("div", { staticClass: "text-xs font-semibold" }, [
                    _vm._v("Target 1")
                  ]),
                  _vm._v(" "),
                  _vm.template === "mastered_targets"
                    ? _c("div", { staticClass: "text-xs" }, [
                        _vm._v("\n        Mastered\n      ")
                      ])
                    : _c("div", { staticClass: "text-xs" }, [
                        _vm._v("\n        In acquisition\n      ")
                      ])
                ]
              ),
              _vm._v(" "),
              _c("ExampleTargetGraph", { staticClass: "w-full" })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.template === "selected_curricula_or_target_types"
        ? _c(
            "div",
            { attrs: { id: "exmaple-target-graph-2" } },
            [
              _vm._m(2),
              _vm._v(" "),
              _c("ExampleTargetGraph2", { staticClass: "w-full" })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "px-6.5 h-10 flex items-center justify-center",
        attrs: { id: "template-title" }
      },
      [
        _c("div", { staticClass: "text-slate-1000 font-bold" }, [
          _vm._v("Your report title")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "py-1 flex items-center justify-center text-slate-1000" },
      [
        _c("div", { staticClass: "text-xs font-semibold" }, [
          _vm._v("Cumulative Graph")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "py-1 flex flex-col items-center justify-center text-slate-1000"
      },
      [
        _c("div", { staticClass: "text-xs font-semibold" }, [
          _vm._v("Target 2")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-xs" }, [_vm._v("Mastered")])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19b5388c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19b5388c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/report/TemplateExample.vue
// module id = null
// module chunks = 